import { render, staticRenderFns } from "./id.vue?vue&type=template&id=2a229d8b&scoped=true"
import script from "./id.vue?vue&type=script&lang=ts"
export * from "./id.vue?vue&type=script&lang=ts"
import style0 from "./id.vue?vue&type=style&index=0&id=2a229d8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a229d8b",
  null
  
)

export default component.exports